<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" :data="this.dataProps" />
    <form class="content-plans-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12">
          <div class="content-input-default">
            <input
              type="text"
              name="name"
              v-model="statusSchedule.name"
              value=""
              placeholder="Nome"
              required
            />
          </div>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Profissionais",
          routerName: "Professional",
        },
        {
          name: "Novo status de agendamento",
          routerName: "RegisterStatusSchedule",
        },
      ],
      statusSchedule: {
        name: "",
      },
      statusScheduleParams: this.$route.params,
      selectedCategory: "",
      dataProps: { module: "Professional" },
    };
  },
  computed: {
    ...mapGetters({
      user: "User/user",
      statusScheduleData: "Professional/statusSchedule",
    }),
  },
  components: {
    Breadcrumb,
  },
  methods: {
    ...mapActions("Professional", [
      "registerStatusSchedule",
      "consultStatusSchedule",
      "setDataDefault",
    ]),
    async handleSubmit() {
      let message = this.statusSchedule?.id
        ? "Status do agendamento editado com sucesso!"
        : "Status do agendamento cadastrado com sucesso!";

      await this.registerStatusSchedule(this.statusSchedule);
      this.$router.push({ name: "ListStatusSchedule" });
      this.$swal.fire({
        icon: "success",
        html: message,
      });
    },
  },
  async mounted() {
    if (
      this.statusScheduleParams &&
      Object.keys(this.statusScheduleParams).length > 0
    ) {
      await this.consultStatusSchedule(this.statusScheduleParams);
      this.dataProps = {
        name: this.statusScheduleData.name,
        id: this.statusScheduleParams.id,
        module: "Professional",
        type: "StatusSchedule",
      };
      this.statusSchedule = this.statusScheduleData;
      this.links[1].name = this.statusSchedule.name;
    }
  },
};
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px) {
    margin-top: 50px;
  }
}
</style>
